import {localStorageService} from '../services/service-factory';

export default {
  data: function() {
    return {
      localStorageService: undefined
    };
  },
  created() {
    this.localStorageService = localStorageService;
  }
};
